
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VoronoiCellsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, height } = pc;
        const spacing = (300 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const points: {x: number, y: number}[] = [];
        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                points.push({
                    x: x + this.pseudoRandom(x + layerIndex) * spacing,
                    y: y + this.pseudoRandom(y + layerIndex) * spacing
                });
            }
        }

        const draw = () => {
            // Approximated Voronoi via lines to neighbors
            for (let i = 0; i < points.length; i++) {
                const p1 = points[i];
                // Connect to a few nearby points to form a web
                for (let j = i + 1; j < Math.min(i + 5, points.length); j++) {
                    const p2 = points[j];
                    ctx.beginPath();
                    ctx.moveTo(p1.x, p1.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
